module.exports = __webpack_public_path__ + "static/HOME_PARTNERS-SOPRIS-WANCLOUDS.d2c6cf27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HOME_PARTNERS-SOPRIS-WANCLOUDS.png
// module id = 515
// module chunks = 35783957827783